import { isEqual, isString } from 'lodash'
import EditorJSModel from './editorJS'

export default class RichTextModel {
    public type: 'text' | 'editorjs'
    public data: string | EditorJSModel = ''

    public constructor(data: Record<string, any> | null) {
        this.type = data && data.type ? data.type : 'text'
        this.data =
            data && data.data
                ? isString(data.data)
                    ? data.data
                    : new EditorJSModel(data.data)
                : ''
    }

    get tes() {
        return 'test'
    }

    get text(): string {
        if (isString(this.data)) {
            return this.data
        } else {
            return this.data.str
        }
    }

    set text(data: string) {
        this.type = 'text'
        this.data = data
    }

    get editorjsModel(): EditorJSModel {
        if (isString(this.data)) {
            return new EditorJSModel({
                blocks: [{ type: 'paragraph', data: { text: this.data } }],
            })
        } else {
            return this.data
        }
    }

    get editorjs() {
        return {
            version: this.editorjsModel.version,
            time: this.editorjsModel.time,
            blocks: this.editorjsModel.blocks,
        }
    }

    set editorjs(data) {
        this.type = 'editorjs'
        this.data = new EditorJSModel(data)
    }
}
